import { SWITCH } from 'app/config/switch';

export * from './block-size';
export * from './health-status';
export * from './indicator';
export * from './mo';
export * from './product-model';
export * from './running-status';

export const Consts = {
    /*常用日期时间格式*/
    DATE_FORMAT: 'yyyy-MM-dd',
    TIME_FORMAT: 'hh:mm:ss',
    DATETIME_FORMAT: 'yyyy-MM-dd hh:mm:ss',

    /* 图形颜色值常量 */
    COLOR: {
        COLOR_GREEN: '#5ecc49',
        COLOR_BLUE: '#5ecc49',
        COLOR_RED: '#fc5043',
        CLOLOR_ORANGE: '#ffa235',
        COLOR_GREY: '#cccccc',
        COLOR_THIN_GREY: '#e5e5e5',
    },
};

// 设置接口返回的状态值
export const ERROR_OK = 0;

// 是否支持加密登录
export const USE_ENCRYPT_LOGIN = false;

// 性能监控空占位符
export const CHART_EMPTY_DATA = '-';

/**
 * 常用日期+时间格式化形式
 */
export const TIME_FORMATTER = {
    DEFAULT: 'YYYY-MM-DD HH:mm:ss',     // 默认日期+时间格式化形式
    DATE: 'YYYY-MM-DD',                 // 默认日期格式化形式
    TIME: 'HH:mm:ss',                    // 默认时间格式化形式
};

/**
 * 常用字段状态
 */
export enum FS_STATUS {
    ONLINE = 'online',                   // 在线
    OFFLINE = 'offline',                 // 离线
    ROLLBACK = 'rollback',              // 正在回滚
    FAULTY = 'faulty',                   // 故障
    NORMAL = 'normal'                    // 正常
}

export enum PERMISSION {
    canWrite = 2,   // 可写
    canRead = 1,    // 可读
    canNot = 0      // 无权限
}

/**
 * 语言模式
 */
export enum LanguageE {
    /**
     * 中文
     */
    ZH = 'zh',
    /**
     * 英文
     */
    EN = 'en',
    /**
     * 日语
     */
    JA = 'ja',
}

/**
 * 不显示的占位符
 */
export const UNPLACEHOLDER = '--';

/* 速度单位 */
export const SPEED_UNIT = {
    LOW: 'low',
    medium: 'medium',
    high: 'high',
    highest: 'highest',
};

/**
 * 本地存储key值
 */
export const STORAGE_KEY = {
    // 会话过期时间
    EXPIRES_TIME: '__EXPIRES_TIME__',
    // 用户类型
    SCOPE: '__USER_SCOPE__',
    // 告警提示音开关
    ALARM_VOICE_ENABLED: 'alarmVoiceEnabled',
    // 最小告警等级
    MIN_ALARM_LEVEL: 'minAlarmLevel',
    // task任务
    TASKS: 'tasks',
    // 本地存储的用户名是否已经hash处理
    USER_NAME_HASHED_FLAG: 'strMask',
    // 新手引导开关
    QUICK_START_OPEN: 'quickStartOpen',
    // 极简模式
    SIMPLE_MOD: 'simpleMode',
    // whats new开关
    HOME_QUICK_START_OPEN: 'homeQuickStartOpen',
    // 界面缩放非100%不再提示标志
    ZOOM_CHECK: 'zoom-check',
    /**
     * 阵列是否有部署防勒索应用标记 [控制数据保护防勒索入口是否进向导部署防勒索]
     */
    ANTIRANSOMWARE_APPLICATION_CHECK: 'antiransomwareApplicationCheck',
    /**
     * 阵列是否有备份一体机应用标记 [控制初始化界面是否提供一键安装备份一体机入口]
     */
    BACKUP_APPLICATION_CHECK: 'backupApplicationCheck',
    /**
     * 故障树诊断任务显示模式
     */
    DIAGNOSIS_TASK_SHOW_MODE: 'diagnosisTaskShowMode',
};

export const USER_PASSWORD_STATE = {
    EXPIRATION: 3,
    INIT: 4,
    FOCE_CHANGE: 6,
    EXPIRING: 5,
    INIT_PASSWORD: 9,
    // 需要RADIUS一次性认证
    RADIUS_AUTH: 10,
    // 需要RADIUS挑战应答
    RADIUS_CHALLENGE: 11,
};

export const SYSTEM_STATE = {
    // 系统状态正常
    NORMAL: 0,
};

export const MAPPING_TYPE = {
    // 映射到主机
    TO_HOST: 1,
    // 映射到主机组
    TO_HOSTGROUP: 2,
    // 映射到LUN
    TO_LUN: 3,
    // 映射到LUN组
    TO_LUNGROUP: 4,
};

export const INVALID_NUM = 4294967295;

export const INVALID_VSTORE_ID = '4294967295';

export const INFINITE_NUM_64 = '18446744073709551615';

/**
 * LICENSE文件中设备型号与当前设备型号不匹配错误码
 */
export const LICENSE_MODE_DIFFERENT_ERROR = 1077951806;

/**
 * 无权限的错误码列表
 */
export const NO_PERMISSION_ERROR = [1077949058, 1073793463, -1036];

/**
 * cookie白名单（cookieService.clear方法不会清除白名单中的cookie，目前只有DME IQ远程协助需求使用）
 */
export const COOKIE_NO_NEED_CLEAR_WHITELIST = ['xsrfToken'];

export const USER_SCOPE = {
    SSO: 7,
};

export enum LUN_SUBTYPE {
    CUSTOM = 0,
    VVOl = 1,
    PE = 2,
    InBand = 5,
    COMPUTATIONALSTORAGE = 6,
    CHANNEL = 7
}

export enum LifProtoCol {
    NONE = 0,
    /**
     * 单独NFS
     */
    NFS = 1,
    /**
     * 单独CIFS
     */
    CIFS = 2,
    /**
     * NFS+CIFS
     */
    NFSAndCIFS = 3,
    ISCSI = 4,
    /**
     * NFS 和  NFS+CIFS
     */
    NFS_NFSAndCIFS = 5,
    /**
     * CIFS 和  NFS+CIFS
     */
    CIFS_NFSAndCIFS = 6,
    /**
     * S3
     */
    S3 = 8192,
    FC_FCoE = 8,
    NVMe_Over_RoCE = 64,
    REPLICATION = 128,
    BGP = 512,
    DataTurbo = 1024,
    DataTurboStr = '1024',
    DataTurbo_Over_RoCE = 2048,
    NFS_over_RDMA = 4096
}

export enum ServiceType {
    BLOCk = 'block',
    File = 'file',
    All = 'all'
}

export enum EthPhysicalType {
    ETH = 1,
    RoCE = 2
}

export enum EthPortSelectType {
    /** 主机端口/业务端口 */
    BUSSINESS = 0,
    /** 管理端口 */
    MANAGEMENT = 2,
    /** 维护端口 */
    MAINTENANCE = 4,
    /** 容器前端端口 */
    CONTAINER_FRONT = 13,
    /** 容器后端端口 */
    CONTAINER_BACK = 14
}

export enum EthPortLogicType {
    /** 前端端口 */
    BUSSINESS = 0,
    /** 级联端口 */
    EXPANSION = 1,
    /** 管理端口 */
    MANAGEMENT = 2,
    /** 维护端口 */
    MAINTENANCE = 4,
    /** 管理/业务混合口 */
    MANAGEMENT_SERVICE = 5,
    /** 维护/业务混合口 */
    MAINTENANCE_SERVICE = 6,
    /** Scale-Out互联端口 */
    SCALEOUT = 11,
    /** 容器前端端口 */
    CONTAINER_FRONT = 13,
    /** 容器后端端口 */
    CONTAINER_BACK = 14,
    /** 交换端口 */
    SWITCH_PORT = 16
}

/**
 * 端口业务类型
 */
export enum EthPortSrvModeE {
    // 前端端口
    FRONT_END_PORT = 1,
    // 后端端口
    BACK_END_PORT = 2,
    // 交换端口
    SWITCH_PORT = 3,
    // 备件
    SPARE_PORT = 4,
    // 前端RoCE端口
    FRONT_END_ROCE_PORT = 5,
    // 容器前端端口
    CONTAINER_FRONT_END = 6,
    // 容器后端端口
    CCONTAINER_BACK_END = 7,
    // 前端NOF端口
    FRONT_END_ROF_PORT = 8,
    // 前端CloudVxLAN端口
    CLOUD_VXLAN = 9,
    // 前端Cloud-Dtoe-VxLAN端口
    CLOUD_DTOE_VXLAN = 10,
}

export enum RssType {
    /** 可以做NAS复制主端的对象 */
    nasReplicationPrimary = 23,
    /** 可以做NAS复制从端的对象 */
    nasReplicationSlave = 24,
    /** 查询远程复制可用的本端文件系统 */
    localFsForRemoteReplication = 38,
    /** 查询远程复制可用的远端文件系统 */
    remoteFsForRemoteReplication = 39,
    /** 查询可以创建NAS双活的主端文件系统 */
    localFsForHyperMetro = 27,
}

/**
 * 文件系统默认应用类型ID
 */
export enum DefaultFsWorkloadTypeE {
    /** 非OceanProtect设备 */
    NAS_default = '11',
    /** OceanProtect设备 */
    Nas_Backup_Default = '1029',
    /** 老版本OceanProtect设备 */
    Old_Nas_Backup_Default = '1027',
    /** VDP全局重删需求新增 */
    Reduction_Global_Mode = '1040'
}

/**
 * LUN、LUN组默认应用类型ID
 */
export enum DefaultLunWorkloadTypeE {
    /** 非OceanProtect设备 */
    Default = '0',
    /** OceanProtect设备 */
    San_Backup_Default = '1026'
}

/**
 * 传输协议类型
 */
export enum TransTypeE {
    HTTPS = '0',
    SMTP = '1'
}

export enum SnapshotCreateModeE {
    /** 直接新创建快照/快照一致性组 */
    newCreate = '0',
    /** 目标LUN/LUN组创建快照/快照一致性组 */
    targetObjCreate = '1'
}

export enum SetTypeE {
    /**
     * 配置邮箱服务端
     */
    Server = 1,
    /**
     * 成配置告警邮箱客户端
     */
    Client = 2,
    /**
     * 配置邮箱服务端和告警客户端
     */
    Alarm = 3
}

export enum EncryptionModeE {
    /**
     * 不加密
     */
    NotSSL = 0,
    /**
     * SSL/TLS
     */
    SSL = 1,
    /**
     * STARTTLS
     */
    STARTTLS = 3
}

/*
* 闲时模式 workday:0 weekend:1 all:2
*/
export enum WeeklyE {
    workday = '0',
    weekend = '1',
    all = '2'
}

/**
 * 闲时任务 启动=‘1’，停止=‘2’
 */
export enum IdleTaskE {
    start = '1',
    end = '2'
}

/**
 * NFS权限枚举 0:只读 1:读写 5:无
 */
export enum NfsPermissionE {
    onlyRead = '0',
    readAndWrite = '1',
    none = '5'
}

/**
 * NFS写入模式枚举 0:同步 1:异步
 */
export enum NfsWriteModeE {
    sync = '0',
    async = '1'
}

/**
 * 文件系统类型
 */
export enum FileSystemModeE {
    /**
     * 普通文件系统
     */
    COMMON = '0',
    /**
     * worm文件系统
     */
    WORM = '1',
    /**
     * hash文件系统
     */
    HASH = '5',
    /**
     * SmartMobility内部文件系统
     */
    SMART_MOBILITY_INNER_FILE_SYSTEM = '6',
}

/**
 * worm文件系统模式
 */
export enum wormTypeE {
    /**
     * 法规遵从模式
     */
    compliance = 1,
    /**
     * 企业遵从模式
     */
    enterprise = 3
}

/**
 * 时间单位枚举
 */
export enum TimeUnitE {
    /**
     * 年
     */
    YEAR = 48,
    /**
     * 月
     */
    MONTH = 47,
    /**
     * 日
     */
    DAY = 46,
    /**
     * 小时
     */
    HOUR = 45,
    /**
     * 分钟
     */
    MINUTE = 44
}

/**
 * 邮件服务状态
 */
export enum EmailServiceStatusE {
    CLOSE = '0',
    OPEN = '1'
}

/**
 * 物理形态
 */
export enum MorphaE {
    DISK = 0,
    CARD = 1
}

/**
 * 初始化页面存储池信息轮询间隔(ms)
 */
export const InitializePoolInterval = 5000;

/**
 * 容量自适应策略
 */
export enum CapacityPolicyE {
    // 不使用容量自适应
    DISABLED = '0',
    // 自动扩容
    AUTOEXPANSION = '1',
    // 自动缩容或扩容
    AUTOEXPANSIONANDREDUCTION = '2',
}

export enum FailoverGroupServiceType {
    /** NAS+BGP 归属于太网漂移组*/
    NAS = 0,
    BGP = 3,
    /** RDMA 归属于RoCE漂移组*/
    RDMA = 4,
    /** S3 归属于太网漂移组*/
    S3 = 5,
}

/**
 * 接口卡类型
 */
export enum ServiceModeE {
    // 存储前端
    FrontEnd = 1,
    // 存储后端
    BackEnd = 2,
    // ScaleOut
    ScaleOut = 3,
    // BackUp
    BackUp = 4,
    // FrontNoF
    FrontNoF = 5,
    // 容器前端
    ContainerFrontEnd = 6,
    // 容器后端
    ContainerBackEnd = 7,
    // 存储
    FrontNoFActive = 8,
    // CloudVxLAN
    CLOUD_VXLAN = 9,
    // Cloud-Dtoe-VxLAN
    CLOUD_DTOE_VXLAN = 10,
    // 虚拟机前端
    VM_FRONT_END = 11,
    // 虚拟机后端
    VM_BACK_END = 12,
}

/**
 * 需要过滤的端口类型 eg：13_14_16
 */
export const fliterPortTypeStr = [
    // 容器前端端口
    EthPortLogicType.CONTAINER_FRONT,
    // 容器后端端口
    EthPortLogicType.CONTAINER_BACK,
    // 交换端口
    EthPortLogicType.SWITCH_PORT,
].filter((item) => {
    // 容器前端端口支持配置业务需求 【逻辑端口、VLAN、漂移组支持容器前端口】
    if (SWITCH?.SUPPORT_CONTAINER_FRONT_PORT) {
        return item !== EthPortLogicType.CONTAINER_FRONT;
    }

    return true;
}).join('_');

// 起始值
export const ZERO = 0;

/**
 * 采用新模板显示详情的错误名称
 */
export const NEW_DETAIL_ERROR_NAME = ['preCheckForUpgrade', 'postCheckForUpgrade', 'preActivationCheck', 'postCheckForActive'];

// nasLockingPolicy = 255,表示为无效值
export const INVALID_NASLOCKING_VALUE = '255';

// 615版本租户接口从base权限改为vstore权限，为了进行解密兼容，默认打桩一个系统租户的名字和ID
export const SYSTEM_VSTORE_RES_BATCH = { data: [{ ID: '0', NAME: 'System_vStore' }], error: { code: 0, description: '0' } };
export const SYSTEM_VSTORE_RES_COUNT = { data: { COUNT: '1' }, error: { code: 0, description: '0' } };
export const SYSTEM_VSTORE_RES_SINGLE = { data: { ID: '0', NAME: 'System_vStore' }, error: { code: 0, description: '0' } };
// 绑定口类型
export enum BondPortTypeE {
    // 主机端口
    HOSTPORT = '1',
    // 交换端口
    SWITCHPORT = '2'
}

// 绑定模式
export enum BondModeE {
    // 主备模式
    ACTIVESTANDBYMODE = '1',
    // 动态链路聚合模式
    DYNAMICLINKMODE = '4'
}

/** 给计算型存储返回FC的模拟数据 */
export const FCPORT_RES_BATCH = { data: [], error: { code: 0, description: '0' } };

export const HASH_USER_ID_PREFIX = '**';

// 一个小时毫秒数
export const HOUR_IN_MILLISECONDS = 60 * 60 * 1000;

// 所有租户ID值
export const ALL_VSTORE_ID = '';

// 系统租户ID值
export const SYSTEM_VSTORE_ID = '0';

// 系统租户NAME值
export const SYSTEM_VSTORE_NAME = 'System_vStore';

/** 波动检测页上tip隐藏的标志，存入localStorage */
export const HIDE_ANOMALY_TIP = 'HIDE_ANOMALY_TIP';

/** 是否支持重删 0表示不支持重删，1表示支持重删 */
export enum ProductIsSupportDedupE {
    Disable = 0,
    Enable = 1
}

/**
 * 复制特性类型
 */
export enum FeatureTypeE {
    // 阵列内SmartMove
    SMART_MOVE = 0,
    // 阵列间SmartMove
    INTER_SMART_MOVE = 2,
}

/**
 * 主机操作系统类型
 */
export enum HostOsTypeE {
    LINUX = '0',
    WINDOWS = '1',
    SOLARIS = '2',
    HPUX = '3',
    AIX = '4',
    XEN_SERVER = '5',
    MACOS = '6',
    ESX = '7',
    LINUXVIS = '8',
    WINDOWS_SERVER_2012 = '9',
    ORACLE_VM = '10',
    OPEN_VMS = '11',
    ORACLE_VM_SERVER_FOR_X86 = '12',
    ORACLE_VM_SERVER_FOR_SPARC = '13'
}
/**
 * 带表格的高危提示弹窗固定宽度 800
 */
export const PROMPT_WITH_TABLE_WIDTH = 800;


/**
 * 日历组件最后一天选项的value
 */
export const CALENDAR_LAST_DAY = 99;

/**
 * icon前部分
 */
export const APP_ICON_PREFIX = '#app-icon-';

/**
 * svg路径前半部分
 */
export const SVG_PATH_PREFIX = 'assets/svg/';

/**
 * svg图片后缀
 */
export const SVG_SUFFIX = '.svg';

/**
 * 存储池和LUN的工作模式
 */
export enum StoragePoolAndLunWorkModeE {
    /**
     * Active-Active模式
     */
    AA_MODE = '0',
    /**
     * Active-Passive模式
     */
    AP_MODE = '1',
}
